import {ActionBrick, registerBrick, ErrorFlow, File} from 'olympe';
import {getLogger} from '@olympeio/core';
import XLSX from 'xlsx';

export default class ReadExcelSheets extends ActionBrick {
    /**
     * @override
     */
    init($) {
        this.logger = getLogger('ReadExcelSheets');
    }
    /**
     * @override
     * @protected
     * @param {!BrickContext} $
     * @param {File} file
     * @param {ListDef} sheets
     * @param {function()} forwardEvent
     * @param {function(ListDef)} setExcelSheets
     * @param {function(*)} setErrorFlow
     */
    async update($, [file, sheets], [forwardEvent, setExcelSheets, setErrorFlow]) {
        try {
            // Guards
            if (!(file instanceof File)) {
                throw new Error(`The file input is supposed to be a file`);
            }
            if (typeof sheets !== 'string' && !Array.isArray(sheets)) {
                throw new Error(`The sheets is supposed to be a string or Array`);
            }

            let sheetNames = sheets;
            if (typeof sheets === 'string') {
                try {
                    sheetNames = JSON.parse(sheets);
                } catch (parseError) {
                    setErrorFlow(ErrorFlow.create(`Invalid JSON format for sheet names : ${sheets}`, 0));
                    return;
                }
            }
            const data = await file.getContentAsBinary();
            const workbook = XLSX.read(data, {type: 'array', cellDates: true});
            const excelSheets = [];
            sheetNames.forEach((name) => {
                if (workbook.Sheets.hasOwnProperty(name)) {
                    excelSheets.push({[name]: workbook.Sheets[name]});
                }
            });
            setExcelSheets(excelSheets);
            forwardEvent();
        } catch (error) {
            this.logger.error(error.message);
            setErrorFlow(ErrorFlow.create(error, 2));
        }
    }
}

registerBrick('018f0f2c60e766e15140', ReadExcelSheets);
